import Vue from 'vue'
import VueRouter from 'vue-router'
import notFound from '@/views/404.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/login/login.vue')
  },
  {
    path: '*', // 通配符路由，匹配所有不符合以上定义的路由
	meta: {
		title: 'SHE - SmartHomeEndpoint',
	    keepAlive: true, 
	},
    component: notFound // 显示404页面
  },
  {
    path: '/manindex',
    name: 'manindex',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/mainView/mainView.vue')
  },
  {
    path: '/customerList',
    name: 'customerList',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/customer/customerList/customerList.vue')
  },
  {
    path: '/customerType',
    name: 'customerType',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/customer/customerType/customerType.vue')
  },
  {
    path: '/hemGroup',
    name: 'hemGroup',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/hem/hemGroup/hemGroup.vue')
  },
  {
    path: '/hemHistory',
    name: 'hemHistory',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/hem/hemHistory/hemHistory.vue')
  },
  {
    path: '/hemList',
    name: 'hemList',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/hem/hemList/hemList.vue')
  },
  {
    path: '/hemModel',
    name: 'hemModel',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/hem/hemModel/hemModel.vue')
  },
  {
    path: '/productLibList',
    name: 'productLibList',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/hem/productLibList/productLibList.vue')
  },
  {
    path: '/projectRole',
    name: 'projectRole',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/project/projectRole.vue')
  },
  {
    path: '/projectMember',
    name: 'projectMember',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/project/projectMember.vue')
  },
  {
    path: '/projectPermissions',
    name: 'projectPermissions',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/project/projectPermissions.vue')
  },
  {
    path: '/systemSettings',
    name: 'systemSettings',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/system/systemSettings.vue')
  },
  {
    path: '/systemProject',
    name: 'systemProject',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/system/systemProject.vue')
  },
  {
    path: '/systemRole',
    name: 'systemRole',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/system/systemRole.vue')
  },
  {
    path: '/systemUser',
    name: 'systemUser',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/system/systemUser.vue')
  },
  {
    path: '/systemPermissions',
    name: 'systemPermissions',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/role/system/systemPermissions.vue')
  },
  {
    path: '/message',
    name: 'message',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/projectSource/message/message.vue')
  },
  {
    path: '/setProject',
    name: 'setProject',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/projectSource/setProject/setProject.vue')
  },
  {
    path: '/manageHistory',
    name: 'manageHistory',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/log/manageHistory/manageHistory.vue')
  },
  {
    path: '/operateHistory',
    name: 'operateHistory',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/log/operateHistory/operateHistory.vue')
  },
  {
    path: '/visitHistory',
    name: 'visitHistory',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/log/visitHistory/visitHistory.vue')
  },
  {
    path: '/pjtoperateHistory',
    name: 'pjtoperateHistory',
  	meta: {
  		title: 'SHE - SmartHomeEndpoint',
  	    keepAlive: true, 
  	},
    component: () => import('../views/log/pjtoperateHistory/pjtoperateHistory.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title // 在路由切换前将页面标题设置为meta的title值
  next()
})
export default router
